//
// MetadataTable.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../../lib";
import "../../BIRDModel";
import "./MetadataColumn";

var MetadataTable = createModule("BIRD::MetadataTable", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel"], EventDispatcher, [
    ,
    {
        columns: [1],
        tableModifiedTimeStamp: 7,
        resourceName: 7,
        dataLocale: 7,
        dataSourceList: 7,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default MetadataTable;
